/* istanbul ignore file - to be imported from @vg-faset/utilities once custom Angular build work is done. */
/*
 * This makes a small bar appear if the data is 0.0 or close to it, so that there is something clickable.
 * https://stackoverflow.com/a/52040565
 */

export default {
  id: 'ZeroCompensation',
  beforeDatasetsDraw: function (chart) {
    const meta = chart.getDatasetMeta(0)
    meta.data.forEach((d) => {
      const barHeight = d._view.base - d._view.y
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      if (Math.abs(barHeight) < 3) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        d._view.y = d._view.base - 3 * (Math.sign(barHeight) || 1)
      }
    })
  },
}
